import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Rebate({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 16 16" fill="currentColor">
      <path
        d="M14.31.27,10.53.3a2.63,2.63,0,0,0-.41,0,4.86,4.86,0,0,0-3,.9L.66,6.84A2,2,0,0,0,.5,9.66l4.83,5.41a2,2,0,0,0,1.49.66,2,2,0,0,0,1.32-.58l6.42-5.67A4.89,4.89,0,0,0,16,6.21c0-1.29,0-2.85,0-3.81A2.08,2.08,0,0,0,14.31.27ZM11.89,6.32A2.08,2.08,0,1,1,14,4.24,2.08,2.08,0,0,1,11.89,6.32Z"
        fillRule="evenodd"
      />
    </SvgIcon>
  )
}
